import { compose } from 'redux';
import { setDisplayName, withProps } from 'recompose';

import { initialRate } from 'sharedParts/config/blockConfig/questionNumeric';

import RatingFormField from '../../rating/RatingFormField';
import withNumericRatingIcons from '../withNumericRatingIcons';
import styles from './NumericQuestionFormField.scss';

export default compose(
  setDisplayName('NumericQuestionFormField'),
  withNumericRatingIcons,
  withProps(({ block, block: { segment, startFromZero } }) => ({
    shouldHidePersonalIndex: { mobile: false, desktop: true },
    initialRate,
    startFromZero,
    segmentLabelList: block[segment],
    className: styles.container,
  })),
)(RatingFormField);
